import React from 'react';

import { baseSet } from '@utils/common';
import { setPage } from '@utils/page';
import { randomWord } from '@utils/tools';
import { appMethod as app } from '@utils/app';
import { configWxShare } from '../utils/weixinSdkConfig';

const safeSet = (object, path, value) => {
  return object == null ? object : baseSet(object, path, value)
}

function defineGetter (component, key, getter) {
  Object.defineProperty(component, key, {
    enumerable: true,
    configurable: true,
    get: () => {
      if (getter === 'props') {
        return component.props
      }
      return {
        ...component.props,
        ...component.state
      }
    }
  })
}

export default class OfficialPage extends React.Component {

  id = randomWord(8);

  route = this.props.location.pathname.split('/')[1];
  shareData = {};

  officialPageRef = React.createRef();

  constructor(props) {
    super(props);
    defineGetter(this, 'data', 'state');
    // 设置当前页组件实例
    setPage(this);
    setTimeout(() => {
      this.setShareData();
    }, 3000);
  }

  setData = (obj, callback) => {
    const state = Object.assign({}, this.state)
    Object.keys(obj).forEach(key => {
      safeSet(state, key, obj[key])
    })
    Object.assign(this.state, state)
    this.setState(state)
    setTimeout(() => {
      typeof callback == 'function' && callback()
    }, 0)
  }

  setShareData = () => {
    if (!this.onShareAppMessage) {
      return;
    }
    this.shareData = this.onShareAppMessage();
    let url = this.shareData.path;
    let urlArr = url.split('/');
    url = window.location.origin + '/zc_webapp/' + urlArr[urlArr.length - 1];
    if(!/app_id/.test(url)){
      if(url.indexOf('?') < 0){
        url = url +'?app_id=' + app.getAppId();
      }else{
        url = url +'&app_id=' + app.getAppId();
      }
    }
    this.shareData.path = url;
    if(app.isWeixin()){
      configWxShare({
        title: this.shareData.title,
        link: this.shareData.path,
        imgUrl: this.shareData.imageUrl
      })
    }
  }

  // 分享的点击事件（对小程序分享按钮的另种实现）
  shareClickEvent = () =>{
    app.shareClickEvent();
  }
}


// WEBPACK FOOTER //
// ./src/official-page/OfficialPage.jsx